/**
 * /table & /enjoy · shared sticky translucent header.
 * Light blur over the warm paper background.
 *
 * Renders the `/{slug}` wordmark + "by Concierge®" sub-mark.
 * Pass `slug="enjoy"` for the /enjoy surface.
 */
import React from "react";
import ConciergeSurfaceMenu from "@/components/global/ConciergeSurfaceMenu";
import CrossSurfaceNav from "@/components/global/CrossSurfaceNav";

export function TableHeader({ onHome, slug = "table" }) {
    return (
        <header
            data-testid="table-header"
            className="sticky top-0 z-30"
            style={{
                background: "rgba(244, 239, 230, 0.82)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
                borderBottom: "1px solid var(--t-line)",
            }}
        >
            <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-3">
                <button
                    onClick={onHome}
                    data-testid="table-home-button"
                    className="flex items-baseline gap-2 group"
                    style={{ background: "transparent", border: 0, cursor: "pointer", padding: 0, minWidth: 0 }}
                >
                    <span
                        className="t-serif"
                        style={{ fontSize: 26, fontWeight: 500, letterSpacing: "-0.02em", lineHeight: 1, color: "var(--t-ink)" }}
                    >
                        /{slug}
                    </span>
                    <span
                        className="t-mono uppercase lc-mobile-hide-on-narrow"
                        style={{
                            fontSize: 9,
                            letterSpacing: "0.22em",
                            color: "var(--t-ink3)",
                        }}
                    >
                        by Concierge®
                    </span>
                </button>

                <div className="flex items-center gap-4" style={{ flexShrink: 0 }}>
                    <span
                        className="hidden sm:inline-flex items-center justify-center lc-mobile-hide-on-narrow"
                        title="Concierge® on duty"
                        aria-label="Concierge® on duty"
                        style={{
                            width: 28, height: 28,
                            borderRadius: 999,
                            background: "rgba(10,126,62,0.08)",
                            border: "1px solid rgba(10,126,62,0.28)",
                        }}
                    >
                        <span
                            className="t-pulse"
                            aria-hidden="true"
                            style={{
                                width: 8, height: 8,
                                borderRadius: 999,
                                background: "var(--t-verified)",
                                display: "inline-block",
                            }}
                        />
                    </span>
                    {/* Cross-surface desktop nav · founder ruling 19 Feb 2026
                        late evening · quiet brass dot under the current
                        surface link. Hidden on mobile (the hamburger takes
                        over). */}
                    <CrossSurfaceNav
                        testidPrefix="table-header-nav"
                        size="compact"
                    />
                    {/* Mobile-only compact menu so members can jump between
                        core surfaces (founder ruling 19 Feb 2026 evening). */}
                    <ConciergeSurfaceMenu testid={`${slug}-surface-menu`} />
                </div>
            </div>
        </header>
    );
}
